import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const TimePickerFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('TimePickerField'),
});

export type TimePickerField = z.infer<typeof TimePickerFieldSchema>;